import { environment } from "@environment";
import { isValidUrl } from "@library/shared";
import { PdfLinkToSrc } from "./LinkToSrc";

interface Props {
  type?: "code" | "url" | "video" | "calendar" | "attachment";
  width?: number | string;
  height?: number | string;
  url?: string;

  shape?: string;

  horizontalAlignment?: string;
  verticalAlignment?: string;
}

const assetsUrl: string = `${environment.base}/assets/images/Pdf/`;
export const PdfEmbeddedContent = ({
  type = "code",
  width,
  height,
  url,
  shape = "free",
  horizontalAlignment,
}: Props) => {
  let iconName: string = type;
  if (["code", "url"].includes(type)) {
    iconName = "code";

    if (url) {
      if (url.includes("google.com/maps")) iconName = "map";
      else if (url.includes("typeform")) iconName = "form";
      else if (url.includes("loom")) iconName = "video-loom";
      else if (url.includes("vimeo")) iconName = "video-vimeo";
      else if (url.includes("calendly.com")) iconName = "calendar";
      else if (url.includes("hubspot.com") && url.includes("meetings"))
        iconName = "calendar";
      else if (url.includes("cal.mixmax.com")) iconName = "calendar";
      else if (url.includes("chilipiper.com")) iconName = "calendar";
      else if (url.includes("meetings.salesloft.com")) iconName = "calendar";
      else if (url.includes("meet.yesware.com")) iconName = "calendar";
    }

    if (iconName === "code") {
      url = "Embedded HTML can’t be presented inside of the PDF file.";
    }
  }

  if (type === "video" && url) {
    if (url.includes("loom")) iconName = "video-loom";
    else if (url.includes("vimeo")) iconName = "video-vimeo";
  } else if (type === "calendar" && !url) {
    url = "Embedded HTML can’t be presented inside of the PDF file.";
  }

  const ratio =
    shape == null
      ? undefined
      : shape === "axis-resize"
        ? undefined
        : ["square", "circle"].includes(shape)
          ? "1 / 1"
          : "16 / 9";

  return (
    <div className="pdf-embedded-content" data-sd-cid="bK0nSa2pBOqaL7di">
      <a
        href={isValidUrl(url) ? url : undefined}
        target="_blank"
        rel="noreferrer"
        style={{
          width,
          height: ratio == null ? height : undefined,
          aspectRatio: ratio,
          borderRadius: shape === "circle" ? "100%" : "8px",
          justifySelf: horizontalAlignment,
        }}
        className="pdf-embedded-content__wrapper"
      >
        <div className="pdf-embedded-content__icon">
          <img
            alt={`embedded ${type} icon`}
            src={`${assetsUrl}embedded-${iconName}.svg`}
          />
        </div>
      </a>
      {url && <PdfLinkToSrc src={url} />}
    </div>
  );
};
